import { render, staticRenderFns } from "./OtherWebsiteView.vue?vue&type=template&id=144318f3"
import script from "./OtherWebsiteView.vue?vue&type=script&lang=js"
export * from "./OtherWebsiteView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports